import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  DefaultFormErrors,
  useErrors,
  useRequestResetPasswordToken,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import styled from 'styled-components'
import { CTA, UnderlineCTA, FooterContainer } from '../Styled'
import { Typography, Button, FormError, Input } from '../../../..'

export const ForgotPassword = ({
  goBack,
}: {
  handleClose: () => void
  goBack: () => void
}) => {
  const [showSuccess, setShowSuccess] = useState(false)
  const [email, setEmail] = useState('')
  const {
    password,
    errorMessages,
    send,
    globalValidations,
    placeholders,
    logIn,
  } = useGlobalLabels()
  const onSuccess = () => {
    setShowSuccess(true)
  }

  const [mutate, { isLoading, data, error }] = useRequestResetPasswordToken({
    onSuccess,
  })

  const apiErrors = useErrors<DefaultFormErrors>(error, {
    default: errorMessages?.somethingWentWrong,
  })

  // TODO: remove after email is sent
  useEffect(() => {
    if (data) {
      setTimeout(() => {
        window.location.href = `/resetpassword?token=${(data as any).value}`
      }, 5000)
    }
  }, [data])

  const onSubmit = async (variables: { email: string }) => {
    setEmail(variables.email)
    mutate({ email: variables.email })
  }

  const { handleSubmit, errors, control } = useForm({
    defaultValues: {
      email: '',
    },
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  })

  const hasErrors = !Object.keys(errors).length

  if (showSuccess) {
    return (
      <div>
        <Title>{password?.forgottenPassword}</Title>
        <Text>{password?.changePassPrompt?.initial}</Text>

        <EmailContainer>{email}</EmailContainer>

        <CTA>
          <Button fullWidth variant="green" onClick={goBack}>
            {password?.backToLogIn}
          </Button>
        </CTA>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Title>{password?.forgottenPassword}</Title>
      <Text>{password?.changePassPrompt?.final}</Text>
      <Controller
        placeholder={placeholders?.email}
        control={control}
        name="email"
        rules={{
          required: globalValidations?.fieldIsRequired,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: globalValidations?.invalidEmail,
          },
        }}
        as={<Input id="forgot-password-email" />}
      />
      <FormError errors={errors} fieldName="email" />
      <CTA>
        <Button
          iconPosition="right"
          fullWidth
          type="submit"
          variant={hasErrors ? 'green' : 'disabled'}
          disabled={isLoading}
        >
          {send}
        </Button>
      </CTA>
      <FormError center errors={apiErrors} fieldName="default" />
      <FooterContainer>
        {`${password?.orReturnTo} `}{' '}
        <UnderlineCTA onClick={goBack}>{logIn}</UnderlineCTA>.
      </FooterContainer>
    </form>
  )
}

const Title = styled(Typography).attrs({
  as: 'h6',
  variant: '4',
  color: 'silverTree',
})<any>`
  font-weight: 600;
  text-align: center;
`

const Text = styled(Typography).attrs({
  as: 'p',
  variant: '6',
  color: 'hint',
  className: 'my-4 mx-auto',
})`
  text-align: center;
  line-height: 1.4;
`

const EmailContainer = styled.div`
  text-align: center;
  font-weight: 500;
`
